var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceWithoutMouth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1067_4091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9991 2.9873C0.495996 2.9873 0.0366211 24.8498 0.0366211 29.1748C0.0366211 33.5061 8.971 37.0123 19.9991 37.0123C31.0241 37.0123 39.9616 33.5061 39.9616 29.1748C39.9616 24.8498 39.4991 2.9873 19.9991 2.9873Z",
    fill: "#FCC21B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1895 20.4065C11.7864 20.419 10.6364 19.0722 10.6208 17.4003C10.6051 15.7222 11.7301 14.3534 13.1333 14.3409C14.5333 14.3284 15.6864 15.6753 15.702 17.3534C15.7176 19.0253 14.5926 20.3909 13.1895 20.4065ZM26.9739 20.4065C28.3739 20.4034 29.5083 19.044 29.5051 17.3722C29.502 15.694 28.3614 14.3409 26.9614 14.344C25.5583 14.3472 24.4208 15.7065 24.4239 17.3847C24.4301 19.0565 25.5708 20.4097 26.9739 20.4065Z",
    fill: "#2F2F2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1067_4091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(-0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceWithoutMouth);
export default __webpack_public_path__ + "static/media/face-without-mouth.7d6c0c37ee37c5e8f1f3792e853ddcd3.svg";
export { ForwardRef as ReactComponent };